export default __webpack_public_path__ + "static/media/misc-makeupA-480w.e998e88d.avif";